import { render } from "./PaginationBox.vue?vue&type=template&id=780171df"
import script from "./PaginationBox.vue?vue&type=script&lang=js"
export * from "./PaginationBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\java\\workspace\\yonsei_tams2_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__